import {
  SESSION_STORAGE_KEYS,
  getSessionStorageItem,
} from '@chegg-wt/core/utils/sessionStorage'
import { FormType } from '../constants/form'
import { NEW_PROJECT_ID } from '../constants/projects'
import { AppRouteParams, AppRouteCreators } from '../types/core'
import { CitationData } from '../types/form'

interface FormSession {
  data: CitationData
  route: {
    formType: FormType
    params: AppRouteParams
  }
}

export const getSessionFormData = (): FormSession => {
  try {
    return {
      data: JSON.parse(getSessionStorageItem(SESSION_STORAGE_KEYS.formData)),
      route: JSON.parse(getSessionStorageItem(SESSION_STORAGE_KEYS.formRoute)),
    }
  } catch (error) {
    return {
      data: null,
      route: null,
    }
  }
}

export const afterUpgradingRoute = (
  routes: AppRouteCreators,
  formData: FormSession = getSessionFormData(),
  hasPremiumFlow = false
) => {
  const { data, route } = formData

  const isParamsAvailable = route?.params && Object.keys(route.params).length > 0
  const isFormSessionAvailable = data && isParamsAvailable
  const isProjectIdAvailable = route?.params?.projectId

  if (hasPremiumFlow) {
    if (!isFormSessionAvailable) {
      return routes.toDashboard()
    }
    if (!isProjectIdAvailable) {
      return routes.toCitationListForm({ ...route.params, projectId: NEW_PROJECT_ID })
    }
    return routes.toCitationListForm(route.params)
  }

  if (!isFormSessionAvailable) {
    return routes.toFolders()
  }

  const { formType, params } = route
  switch (formType) {
    case 'new':
      return routes.toNewCitation(params)
    case 'edit':
      return routes.toEditCitation(params)
    case 'manual':
      return routes.toManualCitation(params)
    default:
      return routes.toFolders()
  }
}

export const onClickNoThanks = () => {
  window.history.back()
}
